import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { Redirect } from 'react-router';
import { ModalContext } from '../../contexts/Modal/ModalContext';
import AuthForms from '../AuthForms';

const PageContent = ({children, needsLogin,}) => {

    const { show, hide } = useContext(ModalContext);
    const userContext = useContext( UserContext );
    const [forceHome, setForceHome] = useState(false);
    const [isBlocked, setIsBlocked] = useState(false);

    useEffect( () => {
        if( !userContext.userData.isLogged && needsLogin && !isBlocked ){
            show( { content: <AuthForms onFinishCallback={hide}/>, title: 'Login', onClose: onClose } );
            setIsBlocked( true );
        }else if( userContext.userData.isLogged && isBlocked ) onClose(), hide();
    }, [ userContext.userData.isLogged ]);

    function onClose(){
        if( !userContext.userData.isLogged  ) return setForceHome( true );
        setIsBlocked(false);
    }

    if(  forceHome ) return <Redirect to={'/'}/>
    if( isBlocked ) return <></>;

    return <div>{children}</div>;

};

export default PageContent;